/* URA DNA completion controller only. No layout, cart, variant, payment, or navigation mutations. */
(() => {
  'use strict';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new WeakSet();
  const initFit = (root) => {
    if (!root || controllers.has(root)) return;
    const slot = root.querySelector('[data-ura-dna-fit-slot]');
    const productFit = root.hasAttribute('data-ura4-fit');
    const width = root.querySelector(productFit ? '[data-ura4-fit-width]' : '[data-upf-chest]');
    const length = root.querySelector(productFit ? '[data-ura4-fit-length]' : '[data-upf-length]');
    const result = root.querySelector(productFit ? '[data-ura4-fit-result]' : '.upf-room__result');
    const size = root.querySelector(productFit ? '[data-ura4-fit-size]' : '[data-upf-size]');
    if (!slot || !width || !length || !result || !size) return;
    let chart = null;
    if (productFit) {
      const dataNode = root.querySelector('[data-ura4-fit-data]');
      try { chart = JSON.parse(dataNode?.textContent || '{}'); } catch (_) { return; }
      if (!chart.verified || !chart.hasChart || !Array.isArray(chart.sizes)) return;
    }
    controllers.add(root);
    const touched = new Set();
    let played = false;
    let frame = 0;
    let timer = 0;
    const answerIsValid = () => {
      const answer = size.textContent.trim();
      if (!answer || answer === '—' || answer === '··' || root.classList.contains('is-unavailable')) return false;
      if (productFit) return chart.sizes.some((row) => String(row.size).trim() === answer);
      return root.classList.contains('is-verified');
    };
    const evaluate = () => {
      frame = 0;
      const ready = touched.size >= 2 && answerIsValid();
      slot.dataset.ready = ready ? 'true' : 'false';
      if (!ready || played) return;
      played = true;
      if (motion.matches) return;
      slot.classList.add('is-dna-playing');
      timer = window.setTimeout(() => slot.classList.remove('is-dna-playing'), 680);
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(evaluate); };
    root.addEventListener('input', (event) => {
      if (event.target === width) touched.add('width');
      if (event.target === length) touched.add('length');
      queue();
    }, { passive: true });
    const selector = root.querySelector('[data-upf-product]');
    selector?.addEventListener('change', () => {
      touched.clear();
      played = false;
      slot.dataset.ready = 'false';
      slot.classList.remove('is-dna-playing');
      queue();
    });
    const observer = new MutationObserver(queue);
    observer.observe(result, { childList: true, characterData: true, subtree: true });
    observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    queue();
  };
  const init = (scope = document) => scope.querySelectorAll('[data-ura4-fit], [data-upf]').forEach(initFit);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true }); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
